"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EchoCashLoan = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var cashLoanAuth_1 = require("../../model/cashLoanAuth");
var service_1 = require("../../../library/base/service");
var EchoCashLoan = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(EchoCashLoan, _super);
    function EchoCashLoan() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '现金贷去借钱初始化接口';
        _this.code = '101127';
        _this.desc = '现金贷去借钱初始化接口';
        _this.requestParams = new cashLoanAuth_1.EchoCashLoanRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return EchoCashLoan;
}(service_1.BaseService));
exports.EchoCashLoan = EchoCashLoan;
//# sourceMappingURL=echoCashLoan.js.map